export default {"src":"/_next/static/media/logo.f22e2790.svg","height":35,"width":252,"blurWidth":0,"blurHeight":0};